import { render } from "./ModalMarketplaceRedirect.vue?vue&type=template&id=3b9c3737"
import script from "./ModalMarketplaceRedirect.vue?vue&type=script&lang=js"
export * from "./ModalMarketplaceRedirect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__